var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-jumbotron",
                {
                  staticClass: "p-4 rounded-0",
                  attrs: { "header-level": "6", "bg-variant": "white" }
                },
                [
                  _c("template", { slot: "header" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("message.dashboard.title", {
                            userName: _vm.userName
                          })
                        ) +
                        "\n        "
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isContactPerson && !_vm.isPolicyHolder
        ? _c("dashboard-content-contact-person", { staticClass: "mt-4" })
        : _vm._e(),
      _vm._v(" "),
      _vm.isPolicyHolder
        ? _c("dashboard-content", { staticClass: "mt-4" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c(
                "router-link",
                { staticClass: "infobox-link-faq", attrs: { to: "/faq" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "infoboxFaq rounded-0 h-100",
                      attrs: { title: _vm.$t("message.dashboard.faq.title") }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("message.dashboard.faq.text")
                          )
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-card",
                {
                  staticClass: "rounded-0 h-100",
                  attrs: { title: _vm.$t("message.dashboard.info.title") }
                },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("message.dashboard.info.text"))
                    }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isPolicyHolder
        ? _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "rounded-0 h-100",
                      attrs: {
                        title: _vm.$t("message.dashboard.powerOfAttorney.title")
                      }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "message.dashboard.powerOfAttorney.explanation"
                            )
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("ul", { staticClass: "list-unstyled" }, [
                              _c("li", [
                                _c("span", { staticClass: "ti-printer mr-2" }),
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.dashboard.powerOfAttorney.step1"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("span", {
                                  staticClass: "ti-marker-alt mr-2"
                                }),
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.dashboard.powerOfAttorney.step2"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("span", { staticClass: "ti-email mr-2" }),
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.dashboard.powerOfAttorney.step3"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "offset-2" }, [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "message.dashboard.powerOfAttorney.address"
                                      )
                                    )
                                  }
                                })
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "text-right mt-auto" },
                            [
                              _c(
                                "b-btn",
                                {
                                  attrs: {
                                    href:
                                      "/static/documents/Vollmacht_meine-vertraege.pdf",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "ti-download mr-2"
                                  }),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.dashboard.powerOfAttorney.download"
                                      )
                                    ) + "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d79beb4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d79beb4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = Y8A8
// module chunks = 1